var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"projects-component",attrs:{"id":"projects"}},[_c('div',{staticClass:"container"},[_c(_vm.projectsContentComponent,{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }